import { action } from 'satcheljs';

/**
 * - Navigate to Register page if has no logged in yet
 */
export const checkRegisterNavigateAction = action('checkRegisterNavigateAction');
